import * as React from 'react';
import * as chat from "./style.module.scss";
export const ChatVideo = ({ name, text, video }) => {
  return (
    <section className={chat.chat}>
      <div className={`container ${chat.container}`}>
        <div className={chat.wrap}>
          <h2 className={chat.title}>Кураторский чат глазами школьника</h2>
          <div className={chat.content}>
            <p className={chat.name}>{ name }</p>
            <p className={chat.text}>
              <i>{ text }</i>
            </p>
          </div>
        </div>
          <div className={chat.videoBg}>
            <div style={{position:"relative",paddingTop:"56.25%"}}>
              <iframe
                src={ video }
                title={"Кураторский чат глазами школьника"}
                className={chat.videoFrame}
              />
            </div>
          </div>

      </div>
    </section>
  );
};
